import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function CheckoutSuccess() {
  const { t } = useTranslation();
  return (
    <motion.div
      className="max-w-md mx-auto px-6 py-20 text-center"
      initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.4 }}
    >
      <motion.div
        className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-success/10 border border-success/30 mb-6"
        animate={{ scale: [1, 1.1, 1] }} transition={{ duration: 0.5, delay: 0.2 }}
      >
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-success">
          <motion.polyline points="20 6 9 17 4 12" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.5, delay: 0.3 }} />
        </svg>
      </motion.div>
      <h1 className="font-display text-3xl font-bold mb-3">{t('checkout.success')}</h1>
      <p className="text-muted text-sm mb-8">{t('checkout.successDesc')}</p>
      <Link to="/dashboard" className="inline-block px-6 py-3 rounded bg-primary hover:bg-primary-hover text-white font-medium transition-colors">
        {t('checkout.goToDashboard')}
      </Link>
    </motion.div>
  );
}
